import { useContext } from "react";
import { SettingsContext } from "app/hooks/contexts/SettingsContext";

const useSettings = () => useContext(SettingsContext);
export default useSettings;
